import { today, weekAgo } from "../../../utils/date";

export const domains = [{ label: "All domains", value: "" }, { label: "clickcease.com", value: "clickcease.com" }, { label: "abbawabba.com", value: "abbawabba.com" }];
export const periods = { startDate: today(),  endDate: weekAgo(), key: "rollup" };